//THE WORKING CODE


import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Box, Typography, Alert, Collapse, CircularProgress } from '@mui/material';
import { AlertCircle, Eye, EyeOff, Loader2 } from 'lucide-react';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom';
import { SEARCH_URLS } from '../config/urls';
import {Chip} from '@mui/material'
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { ChevronDown, ChevronUp } from 'lucide-react';
import TaskingStripCard from './tasking/TaskingStripCard';


const ConstellationCard = ({ 
  name, 
  color = '#4CAF50',
  resolution,
  dataType,
  minOrderArea,
  revisit,
  creditsPerSqkm,
  onCardClick,
  isExpanded,
  hasError,
  errorMessage,
  opportunityCount,
  areaCoverage,
  captureTimeRange,
  onToggleExpand,
  onEyeClick,
  isVisible,
  hasStrips,
  stripContent,
}) => {

  const handleExpandToggle = (e) => {
    e.stopPropagation();
    onToggleExpand?.(name, !isExpanded);
  };

  const handleEyeClick = (e) => {
    e.stopPropagation();
    onEyeClick?.(name, !isVisible);
  };

  const handleCardClick = (e) => {
    // Don't trigger if clicking on interactive elements
    if (e.target.closest('button') || e.target.closest('[role="button"]')) {
      return;
    }
    // 👇 Trigger feasibility check when card is clicked
    onCardClick?.(name);
  };

  return (
    <Box 
      onClick={handleCardClick}
      sx={{
        width: '95%',
//        bgcolor: '#1E2126',
        bgcolor:'black',
        pt: 1,
        px: 1,
        pb: 1,
        mb: 1.5,
        cursor: 'pointer',
        border: '1px solid #282d36',
        borderRadius: 1,
        transition: 'all 0.2s ease',
        '&:hover': {
          bgcolor: '#1E2126',
        },
        '&:last-child': {
          mb: 0
        }
      }}
    >
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        mb: 1
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 16, height: 16, borderRadius: 1, bgcolor: color }} />
          <Typography sx={{ color: 'rgb(229, 229, 229)', fontSize: '12px', fontWeight: 500 }}>
            {name}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          {hasStrips && (
            <>
              <Tooltip
                title={isVisible ? 'Hide Coverage' : 'Show Coverage'}
                arrow
                PopperProps={{ sx: { zIndex: 9999 } }}
              >
                <IconButton
                  size="small"
                  onClick={handleEyeClick}
                  sx={{
                    p: 0.5,
                    color: isVisible ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.4)',
                    '&:hover': { 
                      color: isVisible ? '#fff' : '#76b6ff', 
                      backgroundColor: 'transparent' 
                    },
                    transition: 'color 0.2s ease',
                  }}
                >
                  {isVisible ? <EyeOff size={18} /> : <Eye size={18} />}
                </IconButton>
              </Tooltip>
            </>
          )}
          {/* Arrow icon - only show if strips have been generated */}
          {hasStrips && (
            <Tooltip
              title={isExpanded ? 'Collapse' : 'Expand'}
              arrow
              PopperProps={{ sx: { zIndex: 9999 } }}
            >
              <span> {/* ✅ Tooltip anchor wrapper */}
                <IconButton
                  size="small"
                  onClick={handleExpandToggle}
                  sx={{
                    p: 0.5,
                    color: isExpanded ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.4)',
                    '&:hover': { 
                      color: isExpanded ? '#fff' : '#76b6ff', 
                      backgroundColor: 'transparent' 
                    },
                    transition: 'color 0.2s ease, transform 0.3s ease',
                  }}
                >
                  {isExpanded ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                </IconButton>
              </span>
            </Tooltip>
          )}

        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.4, mb: !isExpanded && !hasError ? 1 : 0 }}>
        {/* {[
          `Resolution : ${resolution}m`,
          `Minimum order : ${minOrderArea} sqkm`,
          `${creditsPerSqkm} credits per sqkm`
          // `Sensor : ${dataType}`,
          // `Revisit : ${revisit || 'N/A'}`
        ].map((tag) => (
          <Box
            key={tag}
            sx={{
bgcolor: '#438BFF80', color: 'white', fontSize: '11px', height: 20, minWidth: 140, borderRadius: "5px", textAlign: 'center', px: "1",
            }}
          >
            {tag}
          </Box>
        ))} */}
                      <Chip 
                label={`Resolution : ${resolution || 'Unknown'}m`} 
                sx={{ bgcolor: '#438BFF80', color: 'white', fontSize: '11px', height: 18, minWidth: 110, borderRadius: "5px", textAlign: 'left', px: "0" }} 
              />
              <Chip 
                label={`Minimum order : ${minOrderArea} sqkm`}
                sx={{ bgcolor: '#438BFF80', color: 'white', fontSize: '11px', height: 18, minWidth: 110, borderRadius: "5px", textAlign: 'left', px: "0" }} 
              />
              <Chip 
                label={`${creditsPerSqkm} credits per sqkm`} 
                sx={{ bgcolor: '#438BFF80', color: 'white', fontSize: '11px', height: 18, minWidth: 110, borderRadius: "5px", textAlign: 'left', px: "0" }} 
              />
              {/* <Chip 
                label={`Revisit : ${revisit || 'N/A'}`} 
                sx={{ bgcolor: '#438BFF80', color: 'white', fontSize: '11px', height: 18, minWidth: 110, borderRadius: "5px", textAlign: 'left', px: "0" }} 
              /> */}
      </Box>

      {/* <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
        {[
          `Minimum order : ${minOrderArea} sqkm`,
          `${creditsPerSqkm} credits per sqkm`
        ].map((tag) => (
          <Box
            key={tag}
            sx={{
bgcolor: '#438BFF80', color: 'white', fontSize: '11px', height: 18, minWidth: 110, borderRadius: "5px", textAlign: 'left', px: "0"
            }}
          >
            {tag}
          </Box>
        ))}
      </Box> */}

      {/* Error state */}
      <Collapse in={hasError}>
        <Box sx={{ py: 1 }}>
          <Alert severity="error" sx={{ fontSize: '12px' }}>
            {errorMessage || 'Failed to check feasibility'}
          </Alert>
        </Box>
      </Collapse>

      {/* Expanded content with success data */}
      <Collapse in={isExpanded && !hasError}>
        <Box sx={{ pt: 1, '& > p': { mb: 0.5 } }}>
          <Typography sx={{ fontSize: '12px', color: '#A6B6CE', fontWeight: 'bold' }}>
            Estimated No. of strips : {opportunityCount || 0}
          </Typography>
          <Typography sx={{ fontSize: '12px', color: '#A6B6CE', fontWeight: 'bold' }}>
            % Area covered of AOI : {areaCoverage} %
          </Typography>
          <Typography sx={{ fontSize: '12px', color: '#A6B6CE', fontWeight: 'bold' }}>
            Estimated Time to Capture : {captureTimeRange} 
          </Typography>
          {stripContent}
        </Box>
      </Collapse>
    </Box>
  );
};

const TaskingConstellations = ({ 
    dateRange, 
    drawnCoordinates, 
    onFootprintSelect,
    onSelectionChange,
    loadingHandler,
    filterKey,
    isDrawing = false,
    constellationFilter = [],
    onConstellationsUpdate,
    onEnabledConstellationsUpdate,
    onConstellationsWithStripsUpdate,
    resolutionRange = [0, 3],
    maxOffNadirAngle = 25,
    maxSunElevation = 0,
    onFeasibilityTriggerReady,
    isRestoringTaskingState = false,
    cachedTaskingState = null,
    onTaskingStateReady,
    onClearSelectionsReady,
  }) => {
  const [loadingConstellations, setLoadingConstellations] = useState(new Set()); // Track multiple loading states
  const [error, setError] = useState({
    constellation: null,
    message: null
  });
  const [taskingDetails, setTaskingDetails] = useState({});
  const [constellations, setConstellations] = useState([]);
  const [checkedConstellations, setCheckedConstellations] = useState({});
  const [visibleConstellations, setVisibleConstellations] = useState({}); // Track visibility state
  const [stripSelections, setStripSelections] = useState({});
  
  // Restore from cached state if available
  useEffect(() => {
    if (isRestoringTaskingState && cachedTaskingState) {
      console.log('🔄 [TaskingConstellations] Restoring from cached state', cachedTaskingState);
      if (cachedTaskingState.taskingDetails) {
        setTaskingDetails(cachedTaskingState.taskingDetails);
      }
      if (cachedTaskingState.constellations) {
        setConstellations(cachedTaskingState.constellations);
      }
      if (cachedTaskingState.checkedConstellations) {
        setCheckedConstellations(cachedTaskingState.checkedConstellations);
      }
      // Restore strip selections and visibility
      if (cachedTaskingState.stripSelections) {
        // Filter out null/empty values - only restore actual selections (arrays with items)
        const validSelections = Object.keys(cachedTaskingState.stripSelections).reduce((acc, key) => {
          const value = cachedTaskingState.stripSelections[key];
          if (value && Array.isArray(value) && value.length > 0) {
            acc[key] = value;
          }
          return acc;
        }, {});
        if (Object.keys(validSelections).length > 0) {
          setStripSelections(validSelections);
          console.log('✅ [TaskingConstellations] Restored stripSelections', validSelections);
        } else {
          // If no valid selections, set empty object (not null values)
          setStripSelections({});
          console.log('⏸️ [TaskingConstellations] No valid stripSelections to restore (all were null or empty)');
        }
      }
      if (cachedTaskingState.visibleConstellations) {
        setVisibleConstellations(cachedTaskingState.visibleConstellations);
        console.log('✅ [TaskingConstellations] Restored visibleConstellations', cachedTaskingState.visibleConstellations);
      }
      
      // Expand constellation cards that have selected strips (being rendered on map)
      if (cachedTaskingState.stripSelections) {
        const expandedForSelected = {};
        Object.keys(cachedTaskingState.stripSelections).forEach(constellationName => {
          const selections = cachedTaskingState.stripSelections[constellationName];
          if (selections && Array.isArray(selections) && selections.length > 0) {
            expandedForSelected[constellationName] = true;
          }
        });
        if (Object.keys(expandedForSelected).length > 0) {
          setExpandedConstellations(expandedForSelected);
          console.log('✅ [TaskingConstellations] Expanded constellations with selected strips', expandedForSelected);
        }
      }
      
      // Mark as already triggered so it doesn't auto-trigger again after restoration
      hasAutoTriggeredRef.current = true;
      justRestoredRef.current = true; // Mark that we just restored
      console.log('✅ [TaskingConstellations] Set hasAutoTriggeredRef = true and justRestoredRef = true to prevent re-trigger after restoration');
      
      // Trigger sync to map after a short delay to ensure all state is set
      // Use cached state values directly since React state updates are async
      setTimeout(() => {
        const restoredSelections = cachedTaskingState.stripSelections || {};
        const restoredDetails = cachedTaskingState.taskingDetails || {};
        const restoredConstellations = cachedTaskingState.constellations || [];
        
        console.log('🔄 [TaskingConstellations] Triggering immediate sync after restoration', {
          stripSelectionsCount: Object.keys(restoredSelections).length,
          taskingDetailsCount: Object.keys(restoredDetails).length,
          constellationsCount: restoredConstellations.length,
        });
        
        // Sync each constellation's selected strips to the map using cached values
        Object.keys(restoredSelections).forEach(constellationName => {
          const selectedIds = restoredSelections[constellationName];
          if (selectedIds && Array.isArray(selectedIds) && selectedIds.length > 0) {
            const details = restoredDetails[constellationName];
            if (details && details.opportunities && details.opportunities.length > 0) {
              const constellation = restoredConstellations.find((c) => c.name === constellationName);
              if (!constellation) return;
              
              // Get strips from cached data
              const strips = details.opportunities.map((opportunity, index) => ({
                id: `${constellationName}-strip-${index}`,
                coordinates: opportunity.footprint_coordinates,
                raw: opportunity,
              })).filter((strip) => selectedIds.includes(strip.id));
              
              if (strips.length > 0) {
                console.log(`🔄 [TaskingConstellations] Immediate sync for ${constellationName}`, {
                  selectedIds,
                  foundStripsCount: strips.length,
                });
                
                // Call onFootprintSelect directly with the restored data
                onFootprintSelect({
                  constellation: constellationName,
                  coordinates: strips.map((strip) => strip.raw.footprint_coordinates),
                  color: constellation.color,
                  opportunities: strips.map((strip) => strip.raw),
                  timezone: details.timezone,
                  off_nadir_limit: details.off_nadir_limit,
                });
              }
            }
          }
        });
      }, 200);
    } else if (!isRestoringTaskingState && justRestoredRef.current) {
      // Clear the flag after a short delay when restoration is complete
      setTimeout(() => {
        justRestoredRef.current = false;
        console.log('✅ [TaskingConstellations] Cleared justRestoredRef flag');
      }, 200);
    }
  }, [isRestoringTaskingState, cachedTaskingState]);

  // Sync restored strip selections to map after restoration completes
  useEffect(() => {
    // Wait for restoration to complete AND ensure we have all required data
    if (!isRestoringTaskingState && 
        Object.keys(taskingDetails).length > 0 && 
        Object.keys(stripSelections).length > 0 && 
        constellations.length > 0) {
      // Small delay to ensure state is fully restored and rendered
      const timer = setTimeout(() => {
        console.log('🔄 [TaskingConstellations] Syncing ALL restored strips to map', {
          stripSelections,
          taskingDetailsCount: Object.keys(taskingDetails).length,
          constellationsCount: constellations.length,
        });
        
        // Sync each constellation's selected strips to the map
        Object.keys(stripSelections).forEach(constellationName => {
          const selectedIds = stripSelections[constellationName];
          // Only sync if we have valid selections (array with items)
          if (selectedIds && Array.isArray(selectedIds) && selectedIds.length > 0) {
            // Verify that taskingDetails has data for this constellation
            const details = taskingDetails[constellationName];
            if (!details || !details.opportunities || details.opportunities.length === 0) {
              console.warn(`⚠️ [TaskingConstellations] Cannot sync ${constellationName} - no taskingDetails/opportunities yet`);
              return;
            }
            
            // Verify that getStripCards can find the strips
            const strips = getStripCards(constellationName);
            const foundStrips = strips.filter(strip => selectedIds.includes(strip.id));
            
            if (foundStrips.length === 0) {
              console.warn(`⚠️ [TaskingConstellations] Cannot sync ${constellationName} - no matching strips found`, {
                selectedIds,
                availableStripIds: strips.map(s => s.id),
              });
              return;
            }
            
            console.log(`🔄 [TaskingConstellations] Syncing restored strips to map for ${constellationName}`, {
              selectedIds,
              foundStripsCount: foundStrips.length,
              opportunitiesCount: details.opportunities.length,
            });
            syncSelectedStripsToMap(constellationName, selectedIds);
          }
        });
      }, 500); // Increased delay to ensure all state is restored and rendered
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRestoringTaskingState, taskingDetails, stripSelections, constellations]); // syncSelectedStripsToMap is stable, getStripCards uses taskingDetails/constellations

  // SIMPLE: Store state whenever we have results OR when selections change
  useEffect(() => {
    console.log('🔍 [TaskingConstellations] State storage check', {
      hasCallback: !!onTaskingStateReady,
      isRestoring: isRestoringTaskingState,
      taskingDetailsCount: Object.keys(taskingDetails).length,
      constellationsCount: constellations.length,
      stripSelectionsCount: Object.keys(stripSelections).length,
    });
    
    if (!onTaskingStateReady) {
      console.warn('⚠️ [TaskingConstellations] onTaskingStateReady not provided!');
      return;
    }
    
    if (isRestoringTaskingState) {
      console.log('⏸️ [TaskingConstellations] Skipping - restoring state');
      return;
    }
    
    const hasResults = Object.keys(taskingDetails).length > 0;
    if (!hasResults) {
      console.log('⏸️ [TaskingConstellations] No results yet');
      return;
    }
    
    // Filter out null/empty values from stripSelections - only store actual selections (arrays)
    const validStripSelections = Object.keys(stripSelections).reduce((acc, key) => {
      const value = stripSelections[key];
      if (value && Array.isArray(value) && value.length > 0) {
        acc[key] = value;
      }
      return acc;
    }, {});
    
    // Create state key that includes selections to detect when they change
    const selectionsKey = JSON.stringify(validStripSelections);
    const stateKey = `${filterKey}-${Object.keys(taskingDetails).length}-${constellations.length}-${selectionsKey}`;
    if (lastStoredStateRef.current === stateKey) {
      console.log('⏸️ [TaskingConstellations] Already stored this state');
      return; // Already stored this state
    }
    
    console.log('💾 [TaskingConstellations] CALLING onTaskingStateReady - storing state!', {
      taskingDetailsCount: Object.keys(taskingDetails).length,
      constellationsCount: constellations.length,
      stripSelectionsCount: Object.keys(validStripSelections).length,
      validStripSelections,
      filterKey,
    });
    
    onTaskingStateReady({
      filterKey,
      taskingDetails,
      constellations,
      checkedConstellations,
      stripSelections: validStripSelections, // Store only valid selections (no null values)
      visibleConstellations, // Store visibility state
    });
    
    lastStoredStateRef.current = stateKey;
  }, [onTaskingStateReady, isRestoringTaskingState, filterKey, taskingDetails, constellations, checkedConstellations, stripSelections, visibleConstellations]);
  const [expandedConstellations, setExpandedConstellations] = useState({});
  const [isLoadingConstellations, setIsLoadingConstellations] = useState(false);
  const history = useHistory();
  const isAutoTriggeringRef = useRef(false); // Track if we're auto-triggering to prevent loops
  const hasAutoTriggeredRef = useRef(false); // Track if we've already auto-triggered for current dateRange/AOI
  const checkFeasibilityForConstellationRef = useRef(null); // Ref to store the latest feasibility check function
  const hasInitializedFirstCardRef = useRef(false);
  const isDrawingRef = useRef(false); // Track drawing state to avoid stale closures
  const onFootprintSelectRef = useRef(onFootprintSelect); // Ref to avoid dependency loop
  const lastConstellationsWithStripsRef = useRef(null); // Track last sent data to prevent infinite loops
  const lastStoredStateRef = useRef(null); // Track last stored state to avoid duplicate calls
  const justRestoredRef = useRef(false); // Track if we just finished restoring to prevent immediate re-trigger
  
  // Expose clear selections function to parent
  const clearSelections = useCallback(() => {
    console.log('🧹 [TaskingConstellations] Clearing all strip selections');
    setStripSelections({});
    setVisibleConstellations({});
    // Clear all footprints from map
    onFootprintSelect({ coordinates: [], color: null });
  }, [onFootprintSelect]);

  useEffect(() => {
    if (onClearSelectionsReady) {
      onClearSelectionsReady(clearSelections);
    }
  }, [onClearSelectionsReady, clearSelections]);
  const isAnyFeasibilityLoading = loadingConstellations.size > 0;
  const readyConstellations = useMemo(() => {
    return constellations
      .filter(
        (c) => taskingDetails[c.name]?.opportunities && taskingDetails[c.name].opportunities.length > 0
      )
      .filter(constellation =>
        constellationFilter.length === 0 ||
        constellationFilter.includes(constellation.name)
      );
  }, [constellations, taskingDetails, constellationFilter]);
  // Only check completion for filtered constellations
  const filteredConstellationsForCompletion = constellations.filter(constellation =>
    constellationFilter.length === 0 ||
    constellationFilter.includes(constellation.name)
  );
  
  const allFeasibilityCompleted =
    filteredConstellationsForCompletion.length > 0 &&
    filteredConstellationsForCompletion.every((c) => checkedConstellations[c.name]);

  const getStripCards = (constellationName) => {
    const details = taskingDetails[constellationName];
    if (!details?.opportunities) return [];
    const timezoneLabel = details.timezone || 'UTC';

    return details.opportunities.map((opportunity, index) => ({
      id: `${constellationName}-strip-${index}`,
      coordinates: opportunity.footprint_coordinates,
      passLabel: opportunity.pass_id ? `Pass ${opportunity.pass_id}` : `Pass ${index + 1}`,
      satelliteLabel: opportunity.satellite_name || opportunity.satellite_id || opportunity.satellite || constellationName,
      satelliteId: opportunity.satellite_id,
      access_start: opportunity.access_start,
      access_start_utc: opportunity.access_start_utc,
      timezoneLabel,
      viewingAngle: opportunity.viewing_angle,
      sunElevation: opportunity.sun_elevation,
      color: constellations.find((c) => c.name === constellationName)?.color || '#76b6ff',
      raw: opportunity,
    }));
  };

  const syncSelectedStripsToMap = (constellationName, selectedIds) => {
    const constellation = constellations.find((c) => c.name === constellationName);
    if (!constellation) return;

    if (!selectedIds || selectedIds.length === 0) {
      onFootprintSelect({ constellation: constellationName, coordinates: [], color: null });
      return;
    }

    const strips = getStripCards(constellationName).filter((strip) =>
      selectedIds.includes(strip.id)
    );

    if (strips.length === 0) {
      onFootprintSelect({ constellation: constellationName, coordinates: [], color: null });
      return;
    }

    onFootprintSelect({
      constellation: constellationName,
      coordinates: strips.map((strip) => strip.raw.footprint_coordinates),
      color: constellation.color,
      opportunities: strips.map((strip) => strip.raw),
      timezone: strips[0]?.timezoneLabel,
      off_nadir_limit: taskingDetails[constellationName]?.off_nadir_limit,
    });
  };

  const handleStripSelect = (constellationName, strip) => {
    if (!strip) return;
    setStripSelections((prev) => {
      const prevList = prev[constellationName] || [];
      const isSelected = prevList.includes(strip.id);
      const updated = isSelected
        ? prevList.filter((id) => id !== strip.id)
        : [...prevList, strip.id];
      const nextSelections = { ...prev, [constellationName]: updated };
      syncSelectedStripsToMap(constellationName, updated);
      setVisibleConstellations((prevVisible) => ({ ...prevVisible, [constellationName]: updated.length > 0 }));
      return nextSelections;
    });
  };

  // Keep refs in sync with props
  useEffect(() => {
    isDrawingRef.current = isDrawing;
  }, [isDrawing]);

  useEffect(() => {
    onFootprintSelectRef.current = onFootprintSelect;
  }, [onFootprintSelect]);

  // Helper to check if dateRange matches tasking dates
  // Defined here so it can be used in both reset and auto-trigger useEffects
  const isTaskingDateRange = (startDate, endDate) => {
    if (!startDate || !endDate) return false;
    
    const today = new Date();
    const endDateObj = new Date(today);
    endDateObj.setDate(today.getDate() + 7); // 7 days from today
    
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    
    const taskingStart = formatDate(today);
    const taskingEnd = formatDate(endDateObj);
    
    return startDate === taskingStart && endDate === taskingEnd;
  };

  useEffect(() => {
    // Don't reset if we're restoring from cached state - preserve restored data
    if (isRestoringTaskingState) {
      console.log('[TaskingConstellations] Skipping reset - restoring from cached state');
      return;
    }
    
    // Don't reset if user is actively drawing - preserve existing cards
    if (isDrawingRef.current) {
      console.log('[TaskingConstellations] Skipping reset - user is actively drawing');
      return;
    }

    // Don't reset if dateRange is not tasking dates (e.g., switching to catalog tab)
    // This prevents clearing state when switching tabs
    if (dateRange?.startDate && dateRange?.endDate && !isTaskingDateRange(dateRange.startDate, dateRange.endDate)) {
      console.log('[TaskingConstellations] Skipping reset - dateRange is not tasking dates (probably switching to catalog)', {
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
      });
      return;
    }

    // CRITICAL: Don't reset if we already have taskingDetails populated
    // This prevents clearing state when clicking strips or other interactions
    if (Object.keys(taskingDetails).length > 0) {
      console.log('[TaskingConstellations] Skipping reset - taskingDetails already populated (preserving state)', {
        taskingDetailsCount: Object.keys(taskingDetails).length,
        dateRange: dateRange,
        drawnCoordinatesCount: drawnCoordinates?.length,
        filterKey: filterKey,
      });
      return;
    }
    
    console.log('[TaskingConstellations] RESETTING state - params changed', {
      dateRange: dateRange,
      drawnCoordinatesCount: drawnCoordinates?.length,
      filterKey: filterKey,
      hasTaskingDetails: Object.keys(taskingDetails).length > 0,
    });
    
    // Reset loading state
    setLoadingConstellations(new Set());
    
    // Reset error state
    setError({
      constellation: null,
      message: null
    });
    
    // Reset tasking details
    setTaskingDetails({});
    
    // Reset cache of checked constellations
    setCheckedConstellations({});
    
    // Reset expanded constellations
    setExpandedConstellations({});
    
    // Reset visibility state
    setVisibleConstellations({});
    // DON'T reset stripSelections here - they should persist across parameter changes
    // Only clear when explicitly needed (user action or new search)
    // setStripSelections({});
    
    // Reset footprint selection - clear all constellation footprints
    // Use ref to avoid dependency loop
    if (onFootprintSelectRef.current) {
      onFootprintSelectRef.current({ coordinates: [], color: null });
    }
    
    // Reset auto-trigger flag so feasibility checks can run again for new dateRange/AOI/filters
    hasAutoTriggeredRef.current = false;
    hasInitializedFirstCardRef.current = false;
    // Reset stored state tracking when params change
    lastStoredStateRef.current = null;
  }, [dateRange, drawnCoordinates, filterKey, isRestoringTaskingState]); // Reset when dateRange, drawnCoordinates, or filterKey changes
      
  // Fetch constellation data from API
  useEffect(() => {
    // Only fetch constellation data if coordinates have been drawn
    if (!drawnCoordinates || drawnCoordinates.length === 0) {
      return;
    }
    
    const fetchConstellationData = async () => {
      try {
        setIsLoadingConstellations(true);
        
        const token = localStorage.getItem('token');
        const response = await fetch(SEARCH_URLS.getProductsByOrderType('tasking'), {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.status === 401) {
          alert('Session expired. Please login again.');
          localStorage.removeItem('token');
          history.push('/login');
          return;
        }

        if (!response.ok) {
          throw new Error('Failed to fetch constellation data');
        }

        const data = await response.json();
        
        // Filter products by resolution range
        const [minResolution, maxResolution] = resolutionRange || [0, 3];
        const filteredProducts = data.filter((product) => {
          const productResolution = product.resolution;
          if (productResolution === null || productResolution === undefined) {
            return false; // Exclude products without resolution
          }
          const resolution = parseFloat(productResolution);
          if (isNaN(resolution)) {
            return false; // Exclude products with invalid resolution
          }
          return resolution >= minResolution && resolution <= maxResolution;
        });
        
        // Generate a list of constellations from the filtered products
        const MAP_FRIENDLY_COLORS = [
          '#1E88E5', '#D81B60', '#5E35B1', '#E53935', '#43A047',
          '#6D4C41', '#3949AB', '#8E24AA', '#00897B', '#F4511E',
          '#C0CA33', '#546E7A', '#6A1B9A', '#00838F', '#558B2F',
          '#8D6E63', '#D84315', '#2E7D32', '#283593', '#1565C0',
          '#4527A0', '#00695C', '#FF5722', '#827717', '#1B5E20',
          '#37474F', '#AD1457', '#EF6C00', '#4A148C', '#880E4F'
        ];

        const constellationList = filteredProducts.map((product, index) => {
          const color = MAP_FRIENDLY_COLORS[index % MAP_FRIENDLY_COLORS.length];
          
          return {
            id: product.product_id,
            name: product.product_id,
            color: color,
            resolution: product.resolution || "Unknown",
            dataType: product.data_type || "UNKNOWN",
            minOrderArea: product.min_order_area || 0,
            satellites: product.satellites || [],
            revisit: product.revisit ? `${product.revisit}` : 'N/A',
            creditsPerSqkm: `${product.imagery_unit_price || 0}`,
            areaCoverage: 0,
          };
        });
        
        setConstellations(constellationList);
      } catch (error) {
        console.error('Error fetching constellation data:', error);
      } finally {
        setIsLoadingConstellations(false);
      }
    };

    fetchConstellationData();
  },[history, dateRange, drawnCoordinates, resolutionRange]);

  // Notify parent about constellation updates (for filtering)
  useEffect(() => {
    // Always notify parent, even if empty (so filter can be cleared)
    const constellationNames = constellations.map(c => c.name);
    onConstellationsUpdate?.(constellationNames);
  }, [constellations, onConstellationsUpdate]);

  // Notify parent about which constellations have strips (for enabled state)
  useEffect(() => {
    if (onEnabledConstellationsUpdate) {
      // Get constellations that have opportunities (strips)
      const enabledConstellationNames = constellations
        .filter(c => taskingDetails[c.name]?.opportunities && taskingDetails[c.name].opportunities.length > 0)
        .map(c => c.name);
      onEnabledConstellationsUpdate(enabledConstellationNames);
    }
  }, [constellations, taskingDetails, onEnabledConstellationsUpdate]);

  // Notify parent about constellations with strips (for export)
  useEffect(() => {
    if (onConstellationsWithStripsUpdate) {
      // Get full constellation data with strips for export
      const constellationsWithStripsData = readyConstellations.map(constellation => ({
        name: constellation.name,
        opportunities: taskingDetails[constellation.name]?.opportunities || [],
        timezone: taskingDetails[constellation.name]?.timezone || 'UTC',
      }));
      
      // Only update if data actually changed (prevent infinite loops)
      const dataString = JSON.stringify(constellationsWithStripsData);
      if (lastConstellationsWithStripsRef.current !== dataString) {
        lastConstellationsWithStripsRef.current = dataString;
        onConstellationsWithStripsUpdate(constellationsWithStripsData);
      }
    }
  }, [readyConstellations, taskingDetails, onConstellationsWithStripsUpdate]);

  useEffect(() => {
    if (!hasInitializedFirstCardRef.current && constellations.length > 0) {
      const first = constellations[0]?.name;
      if (first) {
        setExpandedConstellations(prev => ({
          ...prev,
          [first]: true
        }));
        hasInitializedFirstCardRef.current = true;
      }
    }
  }, [constellations]);

  useEffect(() => {
    // Report loading state to parent whenever it changes
    // Pass true if any constellation is loading, false otherwise
    if (loadingHandler) {
      loadingHandler(loadingConstellations.size > 0);
    }
  }, [loadingConstellations, loadingHandler]);

  // Preserve existing cards when drawing starts - only clear loading indicators
  useEffect(() => {
    if (isDrawing) {
      // Only clear loading states, but preserve taskingDetails and checkedConstellations
      // so existing cards remain visible
      setLoadingConstellations(new Set());
      setIsLoadingConstellations(false);
      console.log('[TaskingConstellations] Drawing started - preserved cards, cleared loading states');
    }
  }, [isDrawing]);

  // Auto-trigger feasibility checks for all constellations when AOI or date range changes
  useEffect(() => {
    // Skip if we're restoring from cached state (don't trigger new feasibility checks)
    if (isRestoringTaskingState) {
      console.log('[TaskingConstellations] Skipping auto-trigger - restoring from cached state');
      return;
    }
    
    // Skip if we just finished restoring (prevent immediate re-trigger after restoration completes)
    if (justRestoredRef.current) {
      console.log('[TaskingConstellations] Skipping auto-trigger - just finished restoring');
      return;
    }
    
    // Skip if we're already auto-triggering (prevent loops)
    if (isAutoTriggeringRef.current) {
      return;
    }
    
    // Skip if user is actively drawing (wait for drawing to complete)
    if (isDrawing) {
      console.log('[TaskingConstellations] Skipping feasibility checks - user is actively drawing');
      return;
    }

    // Skip if we don't have all required data
    if (!drawnCoordinates || drawnCoordinates.length === 0) {
      return;
    }

    if (!dateRange?.startDate || !dateRange?.endDate) {
      return;
    }

    // CRITICAL: Only auto-trigger if dateRange matches tasking dates (today to 7 days ahead)
    // This prevents triggering when switching to catalog tab (which has different dates)
    if (!isTaskingDateRange(dateRange.startDate, dateRange.endDate)) {
      console.log('[TaskingConstellations] Skipping auto-trigger - dateRange is not tasking dates (catalog dates?)', {
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
      });
      return;
    }

    // Skip if constellations haven't been loaded yet
    if (constellations.length === 0) {
      return;
    }

    // Skip if any constellation is already loading (wait for current operations to complete)
    if (loadingConstellations.size > 0) {
      return;
    }

    // Skip if we've already auto-triggered for this dateRange/AOI combination
    // We'll reset hasAutoTriggeredRef when dateRange or drawnCoordinates change (handled by the reset effect)
    if (hasAutoTriggeredRef.current) {
      console.log('[TaskingConstellations] Skipping auto-trigger - already triggered for this dateRange/AOI');
      return;
    }

    // Additional check: If we have taskingDetails already populated, don't re-trigger
    // This prevents re-triggering after restoration when state is already loaded
    if (Object.keys(taskingDetails).length > 0) {
      console.log('[TaskingConstellations] Skipping auto-trigger - taskingDetails already populated (probably restored)', {
        taskingDetailsCount: Object.keys(taskingDetails).length,
      });
      // Mark as triggered to prevent future triggers
      hasAutoTriggeredRef.current = true;
      return;
    }

    // Skip if the feasibility check function isn't ready yet
    if (!checkFeasibilityForConstellationRef.current) {
      return;
    }

    // Mark that we're auto-triggering
    isAutoTriggeringRef.current = true;
    hasAutoTriggeredRef.current = true;

    console.log('[TaskingConstellations] Auto-triggering feasibility checks for all constellations', {
      constellationCount: constellations.length,
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
      coordinatesCount: drawnCoordinates.length
    });

    // Trigger feasibility check for filtered constellations only
    const filteredConstellations = constellations.filter(constellation =>
      constellationFilter.length === 0 ||
      constellationFilter.includes(constellation.name)
    );
    
    filteredConstellations.forEach(constellation => {
      checkFeasibilityForConstellationRef.current(
        constellation.name,
        false,
        { force: true }
      );
    });

    // Reset the auto-triggering flag after a short delay
    setTimeout(() => {
      isAutoTriggeringRef.current = false;
    }, 100);
  }, [drawnCoordinates, dateRange, constellations, isDrawing, filterKey, isRestoringTaskingState]);

  // Manual trigger function for feasibility checks (called from search button)
  const triggerFeasibilityChecks = useCallback(() => {
    // Skip if we don't have all required data
    if (!drawnCoordinates || drawnCoordinates.length === 0) {
      console.warn('[TaskingConstellations] Cannot trigger feasibility - no coordinates');
      return;
    }

    if (!dateRange?.startDate || !dateRange?.endDate) {
      console.warn('[TaskingConstellations] Cannot trigger feasibility - no date range');
      return;
    }

    // Skip if constellations haven't been loaded yet
    if (constellations.length === 0) {
      console.warn('[TaskingConstellations] Cannot trigger feasibility - no constellations');
      return;
    }

    // Skip if the feasibility check function isn't ready yet
    if (!checkFeasibilityForConstellationRef.current) {
      console.warn('[TaskingConstellations] Cannot trigger feasibility - function not ready');
      return;
    }

    console.log('[TaskingConstellations] Manually triggering feasibility checks for all constellations', {
      constellationCount: constellations.length,
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
      coordinatesCount: drawnCoordinates.length
    });

    // Trigger feasibility check for filtered constellations only
    const filteredConstellations = constellations.filter(constellation =>
      constellationFilter.length === 0 ||
      constellationFilter.includes(constellation.name)
    );
    
    filteredConstellations.forEach(constellation => {
      checkFeasibilityForConstellationRef.current(
        constellation.name,
        false,
        { force: true }
      );
    });
  }, [drawnCoordinates, dateRange, constellations, constellationFilter]);

  // Expose trigger function to parent via callback
  useEffect(() => {
    if (onFeasibilityTriggerReady) {
      onFeasibilityTriggerReady(triggerFeasibilityChecks);
    }
  }, [onFeasibilityTriggerReady, triggerFeasibilityChecks]);
        
  // Extract feasibility check logic into a reusable function
  const checkFeasibilityForConstellation = async (
    constellationName,
    skipIfChecked = false,
    options = {}
  ) => {
    const { force = false } = options;
    let result = { success: false, details: null };
    // Find constellation by name
    const constellation = constellations.find(c => c.name === constellationName);
    if (!constellation) {
      console.error(`Constellation ${constellationName} not found`);
      return result;
    }
    
    // Basic validation
    if (!dateRange?.startDate || !dateRange?.endDate) {
      setError({
        constellation: constellationName,
        message: 'Please select a date range'
      });
      return result;
    }

    if (!drawnCoordinates || drawnCoordinates.length === 0) {
      setError({
        constellation: constellationName,
        message: 'Please draw an area of interest'
      });
      return result;
    }

    const alreadyChecked = !!checkedConstellations[constellationName];

    // Skip if already checked and skipIfChecked is true
    if (!force && skipIfChecked && alreadyChecked) {
      return result;
    }

    // Only proceed with API call if this is the first time checking this constellation
    if (force || !alreadyChecked) {
      try {
        // First set loading state (add to set without removing others)
        setLoadingConstellations(prev => new Set(prev).add(constellationName));
        setError({ constellation: null, message: null });
        
        // Format coordinates for the API
        const formattedCoordinates = drawnCoordinates.map(coord => [coord.lng, coord.lat]);
        
        // Create date string in the format "YYYY-MM-DD/YYYY-MM-DD"
        const startDate = dayjs(dateRange.startDate).format('YYYY-MM-DD');
        const endDate = dayjs(dateRange.endDate).format('YYYY-MM-DD');
        const dateString = `${startDate}/${endDate}`;
    
        const token = localStorage.getItem('token');

        // Send the full product name to backend so it can match the exact product
        // Backend uses product configuration to determine satellites dynamically
        const payload = {
          coordinates: formattedCoordinates,
          constellation: constellationName,  // Send full product name (e.g., "Cartosat-2 PAN" or "Cartosat-2 PAN-MSI")
          date: dateString,
          constraints: {
            max_off_nadir_angle: maxOffNadirAngle,
            min_sun_elevation: maxSunElevation,
          }
        };
        
        console.log('[TaskingConstellations] Feasibility check payload:', {
          constellation: constellationName,
          max_off_nadir_angle: maxOffNadirAngle,
          min_sun_elevation: maxSunElevation
        });
    
        const response = await fetch(SEARCH_URLS.checkFeasibility, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(payload)
        });
    
        if (response.status === 401) {
          alert('Session expired. Please login again.');
          localStorage.removeItem('token');
          history.push('/login');
          return result;
        }
    
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.detail || 'Failed to check feasibility');
        }
    
        const responseData = await response.json();
        
        // Debug: Log the full response to see what we're getting
        console.log(`[UI DEBUG] Full response for ${constellationName}:`, {
          hasTotalCoverage: 'total_coverage_percentage' in responseData,
          totalCoverageValue: responseData.total_coverage_percentage,
          totalCoverageType: typeof responseData.total_coverage_percentage,
          responseKeys: Object.keys(responseData),
          timezone: responseData.timezone,
          timezoneType: typeof responseData.timezone,
          off_nadir_limit: responseData.off_nadir_limit,
          off_nadir_limitType: typeof responseData.off_nadir_limit
        });
    
        if (responseData.opportunities && responseData.opportunities.length > 0) {
          const timezone = responseData.timezone || 'UTC';
          
          // Sort opportunities by access_start timestamp
          const sortedOpportunities = responseData.opportunities.sort((a, b) => {
            const aTime = a.access_start ? new Date(a.access_start.replace('T', ' ')) : new Date(0);
            const bTime = b.access_start ? new Date(b.access_start.replace('T', ' ')) : new Date(0);
            return aTime - bTime;
          });
    
          const firstStart = sortedOpportunities[0].access_start;
          const lastStart = sortedOpportunities[sortedOpportunities.length - 1].access_start;

          // Format simple date range for card display (without time and duration)
          const formatDateOnly = (timestampStr) => {
            if (!timestampStr) return 'N/A';
            // Parse the timestamp (format: YYYY-MM-DDTHH:MM:SS)
            const [datePart] = timestampStr.split('T');
            const [year, month, day] = datePart.split('-');
            const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            return `${day} ${monthNames[parseInt(month) - 1]} ${year}`;
          };
    
          // Simple date range for card display.
          // If there's only one pass (or both dates are the same), show a single date.
          const firstDate = formatDateOnly(firstStart);
          const lastDate = formatDateOnly(lastStart);
          const captureTimeRange =
            firstDate === lastDate ? firstDate : `${firstDate} to ${lastDate}`;
          
          // Use accurate total coverage from backend (union of all footprints)
          // Fallback to sum if backend doesn't provide it (for backward compatibility)
          let totalCoveragePercentage = responseData.total_coverage_percentage !== undefined 
            ? responseData.total_coverage_percentage 
            : responseData.opportunities.reduce((sum, opportunity) => 
                sum + (opportunity.coverage_percentage || 0), 0);
          
          // Ensure it doesn't exceed 100% (shouldn't happen with accurate calculation, but safety check)
          if (totalCoveragePercentage > 100) {
            totalCoveragePercentage = 100;
          }
          
          console.log(`[UI] ${constellationName}: ${responseData.opportunities.length} opportunities | ${totalCoveragePercentage.toFixed(2)}% coverage | Timezone: ${timezone}${responseData.total_coverage_percentage !== undefined ? ' (from backend)' : ' (calculated)'}`);
          
          const formattedCoverage = `${totalCoveragePercentage.toFixed(2)}%`;
    
          // Create the details object for this constellation
          const constellationDetails = {
              opportunities: responseData.opportunities,
            timezone: timezone,
            off_nadir_limit: responseData.off_nadir_limit,  // Store max tilt angle
              dateRange: {
                start: dateRange.startDate,
                end: dateRange.endDate
              },
              coordinates: drawnCoordinates,
              areaCoverage: totalCoveragePercentage.toFixed(2),
              captureTimeRange: captureTimeRange
          };
    
          // Use functional form of setState to ensure we have the latest state
          // This prevents race conditions where multiple API calls overwrite each other's data
          setTaskingDetails(prevDetails => ({
            ...prevDetails,
            [constellationName]: constellationDetails
          }));
          // DON'T clear strip selections when feasibility results come in
          // Preserve existing selections - they should only be cleared when user explicitly deselects
          // This allows selections to persist across feasibility updates
          
          // Mark this constellation as checked
          setCheckedConstellations(prev => ({
            ...prev,
            [constellationName]: true
          }));
          result = { success: true, details: constellationDetails };
        } else {
          // No opportunities found
          setCheckedConstellations(prev => ({
            ...prev,
            [constellationName]: true
          }));
          setTaskingDetails(prevDetails => ({
            ...prevDetails,
            [constellationName]: {
              opportunities: [],
              timezone: responseData.timezone || 'UTC',
              off_nadir_limit: responseData.off_nadir_limit,
              dateRange: {
                start: dateRange.startDate,
                end: dateRange.endDate
              },
              coordinates: drawnCoordinates,
              areaCoverage: '0.00',
              captureTimeRange: 'N/A'
            }
          }));
          result = { success: true, details: null };
        }
      } catch (err) {
        console.error(`Error checking feasibility for ${constellationName}:`, err);
        setError({
          constellation: constellationName,
          message: err.message || 'Failed to check feasibility'
        });
        // Mark as checked even on error to prevent infinite retries
        setCheckedConstellations(prev => ({
          ...prev,
          [constellationName]: true
        }));
        result = { success: false, error: err };
      } finally {
        // Remove from loading set
        setLoadingConstellations(prev => {
          const newSet = new Set(prev);
          newSet.delete(constellationName);
          return newSet;
        });
      }
    }

    return result;
  };

  // Store the latest feasibility check function in ref
  checkFeasibilityForConstellationRef.current = checkFeasibilityForConstellation;

  // 🆕 Handler for visibility toggle (eye icon)
  const handleVisibilityToggle = (constellationName, shouldShow) => {
    const constellation = constellations.find(c => c.name === constellationName);
    if (!constellation) {
      console.error(`Constellation ${constellationName} not found`);
      return;
    }

    setVisibleConstellations(prev => ({
      ...prev,
      [constellationName]: shouldShow
    }));

    if (shouldShow) {
      const selectedIds = stripSelections[constellationName];
      syncSelectedStripsToMap(constellationName, selectedIds);
    } else {
      onFootprintSelect({ 
        coordinates: [], 
        color: null,
        constellation: constellationName
      });
    }
  };

  // 🆕 Handler for card click (triggers feasibility check)
  const handleCardClick = async (constellationName) => {
    // Find constellation ID by name
    const constellation = constellations.find(c => c.name === constellationName);
    if (!constellation) {
      console.error(`Constellation ${constellationName} not found`);
      return;
    }

    const details = taskingDetails[constellationName];
    const opportunities = details?.opportunities || [];
    const hasResults = details && opportunities.length > 0;

    if (hasResults) {
      setExpandedConstellations(prev => ({
        ...prev,
        [constellationName]: !prev[constellationName]
      }));
      return;
    }

    const fetchResult = await checkFeasibilityForConstellation(constellationName, false);
    if (fetchResult.success) {
      setExpandedConstellations(prev => ({
        ...prev,
        [constellationName]: true
      }));
    }
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.6; }
            100% { opacity: 1; }
          }
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          .spinning-icon {
            animation: spin 1s linear infinite !important;
            transform-origin: center !important;
          }

        `}
      </style>
      <Typography sx={{ color: '#76b6ff', fontSize: '12px', fontWeight: 500, py: 0.5, px: 1 }}>
       
      </Typography>

      {isLoadingConstellations && !isDrawing ? (
        <Box sx={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center',
          p: 2 
        }}>
<Loader2 size={32} style={{ 
  color: '#76b6ff', 
  marginBottom: '12px',
  animation: 'spin 1s linear infinite' 
}} />
          <Typography sx={{ color: '#76b6ff', fontSize: '14px' }}>
            Loading Products...
          </Typography>
        </Box>
      ) : (
        <Box sx={{ 
          flex: 1,
          overflowY: 'auto',
          px: 1,
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(255,255,255,0.1) transparent',
          '&::-webkit-scrollbar': {
            width: '2px'
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent'
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(255,255,255,0.1)',
            borderRadius: '1px'
          }
        }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.5, mb: 1 }}>
          <Typography sx={{ color: '#76b6ff', fontSize: '14px', fontWeight: 500 }}>
          Available Constellations to Task
       </Typography>
          {isAnyFeasibilityLoading && !isDrawing && constellations.length > 0 && (
            <Loader2
              size={16}
              style={{
                color: '#76b6ff',
                animation: 'spin 1s linear infinite'
              }}
            />
          )}
        </Box>
          {/* Show loading when fetching products */}
          {isLoadingConstellations && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#9FAEC6', fontSize: '12px', py: 2 }}>
              <Loader2
                size={16}
                style={{
                  color: '#76b6ff',
                  animation: 'spin 1s linear infinite'
                }}
              />
              <span>Loading products...</span>
            </Box>
          )}
          {/* Show message when no products match resolution filter */}
          {!isLoadingConstellations && constellations.length === 0 && (
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
              <Typography sx={{ color: '#A6B6CE', fontSize: '14px', textAlign: 'center' }}>
                No products match the selected resolution filter.
              </Typography>
            </Box>
          )}
          {/* Show loading when checking feasibility (only if we have constellations) */}
          {(isAnyFeasibilityLoading || (!isLoadingConstellations && constellations.length > 0 && !allFeasibilityCompleted && !isDrawing)) && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#9FAEC6', fontSize: '12px', py: 2 }}>
              <Loader2
                size={16}
                style={{
                  color: '#76b6ff',
                  animation: 'spin 1s linear infinite'
                }}
              />
              <span>Fetching feasibility...</span>
            </Box>
          )}
          {/* Show message when feasibility completed but no strips found */}
          {!isLoadingConstellations && constellations.length > 0 && allFeasibilityCompleted && readyConstellations.length === 0 && !isDrawing && (
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
              <Typography sx={{ color: '#A6B6CE', fontSize: '14px', textAlign: 'center' }}>
                No feasible strips found for the selected AOI and dates.
              </Typography>
            </Box>
          )}
          {/* Hide cards while feasibility is loading */}
          {!isAnyFeasibilityLoading && (allFeasibilityCompleted || (isDrawing && readyConstellations.length > 0)) && readyConstellations.map((constellation, index) => {
            const details = taskingDetails[constellation.name] || {};
            const strips = getStripCards(constellation.name);
            const selectedIds = stripSelections[constellation.name] || [];
            const stripContent = strips.length > 0 ? (
              <Box
                sx={{
                  mt: 1.5,
                  maxHeight: 120,
                  overflowY: 'auto',
                  pr: 0.5,
                  '&::-webkit-scrollbar': {
                    width: 4,
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(118,182,255,0.4)',
                    borderRadius: 2,
                  },
                }}
              >
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                    columnGap: 0.8,
                    rowGap: 0.9,
                  }}
                >
                  {strips.map((strip) => (
                    <TaskingStripCard
                      key={strip.id}
                      strip={strip}
                      isSelected={selectedIds.includes(strip.id)}
                      onSelect={(selectedStrip) => handleStripSelect(constellation.name, selectedStrip)}
                    />
                  ))}
                </Box>
              </Box>
            ) : null;

            return (
              <Box
                key={`${constellation.id}-wrapper`}
                sx={{
                  animation: 'fadeSlideIn 0.4s ease forwards',
                  opacity: 0,
                  transform: 'translateY(8px)',
                  animationDelay: `${index * 0.08}s`,
                  mb: 1.5,
                }}
              >
            <ConstellationCard 
              {...constellation}
                  onCardClick={handleCardClick}
              isExpanded={expandedConstellations[constellation.name] === true}
              hasError={error.constellation === constellation.name}
              errorMessage={error.constellation === constellation.name ? error.message : null}
                  opportunityCount={details.opportunities?.length || 0}
                  areaCoverage={details.areaCoverage || constellation.areaCoverage}
                  captureTimeRange={details.captureTimeRange}
                  onToggleExpand={(name, expand) => {
                    setExpandedConstellations(prev => ({ ...prev, [name]: expand }));
                  }}
                  onEyeClick={handleVisibilityToggle}
                  isVisible={visibleConstellations[constellation.name] !== false}
                  hasStrips={strips.length > 0}
                  stripContent={stripContent}
            />
              </Box>
            );
          })}
        </Box>
      )}
      <style>
        {`
          @keyframes fadeSlideIn {
            from {
              opacity: 0;
              transform: translateY(10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </Box>
  );
};

export default TaskingConstellations;


// import React, { useState, useEffect } from 'react';
// import { Box, Typography, Alert, Collapse, CircularProgress } from '@mui/material';
// import { AlertCircle, RefreshCw, Eye, Loader2 } from 'lucide-react';
// import dayjs from 'dayjs';
// import { useHistory } from 'react-router-dom';
// import { SEARCH_URLS } from '../config/urls';

// // Import the updated ConstellationCard component
// // Note: In your project, you would import from the file where it's defined
// const ConstellationCard = ({ 
//   name, 
//   color = '#4CAF50',
//   resolution,
//   dataType,
//   minOrderArea,
//   revisit,
//   creditsPerSqkm,
//   onCardClick,
//   onRefreshClick,
//   isSelected,
//   isExpanded,
//   isLoading,
//   hasError,
//   errorMessage,
//   opportunityCount,
//   areaCoverage,
//   captureTimeRange
// }) => {
//   // Prevent event propagation when clicking refresh icon
//   const handleRefreshClick = (e) => {
//     e.stopPropagation();
//     onRefreshClick(name);
//   };

//   return (
//     <Box 
//       sx={{
//         width: '95%',
//         bgcolor: isSelected ? '#65E0651A' : 'rgba(40, 40, 40, 0.8)',
//         p: 1,
//         mb: 0.5,
//         cursor: 'pointer',
//         border: isSelected ? '1px solid #65E0651A' : '1px solid transparent',
//         transition: 'all 0.2s ease',
//         '&:hover': {
//           bgcolor: isSelected ? '#65E0651A' : 'rgba(40, 40, 40, 0.9)',
//         },
//         '&:last-child': {
//           mb: 0
//         }
//       }}
//       onClick={() => onCardClick(name)}
//     >
//       <Box sx={{ 
//         display: 'flex', 
//         justifyContent: 'space-between', 
//         alignItems: 'center',
//         mb: 1
//       }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//           <Box sx={{ width: 16, height: 16, borderRadius: 1, bgcolor: color }} />
//           <Typography sx={{ color: 'rgb(229, 229, 229)', fontSize: '14px', fontWeight: 500 }}>
//             {name}
//           </Typography>
//         </Box>
//         <Box sx={{ display: 'flex', gap: 1 }}>
//           <Eye size={20} style={{ color: '#A1A1AA', cursor: 'pointer' }} />
//           <RefreshCw 
//             size={20} 
//             style={{ 
//               color: '#A1A1AA', 
//               cursor: 'pointer',
//               animation: isLoading ? 'spin 1s linear infinite' : 'none' 
//             }} 
//             onClick={handleRefreshClick}
//           />
//         </Box>
//       </Box>

//       <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
//         {[
//           `Resolution : ${resolution}m`,
//           `Sensor : ${dataType}`,
//           `Revisit : ${revisit || 'N/A'}`
//         ].map((tag) => (
//           <Box
//             key={tag}
//             sx={{
//               px: 1,
//               py: 0.25,
//               bgcolor: 'rgba(66, 135, 245, 0.3)',
//               color: '#B9CEF0',
//               fontSize: '12px',
//               borderRadius: 0
//             }}
//           >
//             {tag}
//           </Box>
//         ))}
//       </Box>

//       <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
//         {[
//           `Minimum order : ${minOrderArea} sqkm`,
//           `${creditsPerSqkm} credits per sqkm`
//         ].map((tag) => (
//           <Box
//             key={tag}
//             sx={{
//               px: 1,
//               py: 0.25,
//               bgcolor: 'rgba(66, 135, 245, 0.3)',
//               color: '#B9CEF0',
//               fontSize: '12px',
//               borderRadius: 0
//             }}
//           >
//             {tag}
//           </Box>
//         ))}
//       </Box>

//       {/* Loading state */}
//       <Collapse in={isLoading}>
//         <Box sx={{ 
//           display: 'flex', 
//           alignItems: 'center', 
//           justifyContent: 'center',
//           py: 1
//         }}>
//           <Loader2 size={24} style={{ 
//             color: '#76b6ff', 
//             animation: 'spin 1s linear infinite' 
//           }} />

//           <Typography sx={{ ml: 2, color: '#76b6ff', fontSize: '12px' }}>
//             Checking feasibility...
//           </Typography>
//         </Box>
//       </Collapse>

//       {/* Error state */}
//       <Collapse in={hasError}>
//         <Box sx={{ py: 1 }}>
//           <Alert severity="error" sx={{ fontSize: '12px' }}>
//             {errorMessage || 'Failed to check feasibility'}
//           </Alert>
//         </Box>
//       </Collapse>

//       {/* Expanded content with success data */}
//       <Collapse in={isExpanded && !isLoading && !hasError}>
//         <Box sx={{ '& > p': { mb: 0.5 } }}>
//           <Typography sx={{ fontSize: '12px', color: 'rgba(166, 182, 206, 0.8)' }}>
//             Estimated No. of strips : {opportunityCount || 0}
//           </Typography>
//           <Typography sx={{ fontSize: '12px', color: 'rgba(166, 182, 206, 0.8)' }}>
//             % Area covered of AOI : {areaCoverage} %
//           </Typography>
//           <Typography sx={{ fontSize: '12px', color: 'rgba(166, 182, 206, 0.8)' }}>
//             Estimated Time to Capture : {captureTimeRange} 
//           </Typography>
//         </Box>
//       </Collapse>
//     </Box>
//   );
// };

// const TaskingConstellations = ({ 
//     dateRange, 
//     drawnCoordinates, 
//     onFootprintSelect,
//     onSelectionChange,
//     loadingHandler
//   }) => {
//   const [selectedConstellation, setSelectedConstellation] = useState(null);
//   const [loadingConstellation, setLoadingConstellation] = useState(null);
//   const [error, setError] = useState({
//     constellation: null,
//     message: null
//   });
//   const [taskingDetails, setTaskingDetails] = useState({});
//   const [constellations, setConstellations] = useState([]);
//   const [checkedConstellations, setCheckedConstellations] = useState({});
//   const [expandedConstellations, setExpandedConstellations] = useState({});
//   const [isLoadingConstellations, setIsLoadingConstellations] = useState(false);
//   const history = useHistory();

//   useEffect(() => {
//     // Reset selected constellation
//     setSelectedConstellation(null);
    
//     // Reset loading state
//     setLoadingConstellation(null);
    
//     // Reset error state
//     setError({
//       constellation: null,
//       message: null
//     });
    
//     // Reset tasking details
//     setTaskingDetails({});
    
//     // Reset cache of checked constellations
//     setCheckedConstellations({});
    
//     // Reset expanded constellations
//     setExpandedConstellations({});
    
//     // Reset footprint selection
//     onFootprintSelect({ coordinates: [], color: null });
//   }, [dateRange]);
      
//   // Fetch constellation data from API
//   useEffect(() => {
//     // Only fetch constellation data if coordinates have been drawn
//     if (!drawnCoordinates || drawnCoordinates.length === 0) {
//       return;
//     }
    
//     const fetchConstellationData = async () => {
//       try {
//         setIsLoadingConstellations(true);
        
//         const token = localStorage.getItem('token');
//         const response = await fetch(SEARCH_URLS.getProductsByOrderType('tasking'), {
//           headers: {
//             'Authorization': `Bearer ${token}`
//           }
//         });

//         if (response.status === 401) {
//           alert('Session expired. Please login again.');
//           localStorage.removeItem('token');
//           history.push('/login');
//           return;
//         }

//         if (!response.ok) {
//           throw new Error('Failed to fetch constellation data');
//         }

//         const data = await response.json();
        
//         // Generate a list of constellations from the API data
//         const MAP_FRIENDLY_COLORS = [
//           '#1E88E5', '#D81B60', '#5E35B1', '#E53935', '#43A047',
//           '#6D4C41', '#3949AB', '#8E24AA', '#00897B', '#F4511E',
//           '#C0CA33', '#546E7A', '#6A1B9A', '#00838F', '#558B2F',
//           '#8D6E63', '#D84315', '#2E7D32', '#283593', '#1565C0',
//           '#4527A0', '#00695C', '#FF5722', '#827717', '#1B5E20',
//           '#37474F', '#AD1457', '#EF6C00', '#4A148C', '#880E4F'
//         ];

//         const constellationList = data.map((product, index) => {
//           const color = MAP_FRIENDLY_COLORS[index % MAP_FRIENDLY_COLORS.length];
          
//           return {
//             id: product.product_id,
//             name: product.product_id,
//             color: color,
//             resolution: product.resolution || "Unknown",
//             dataType: product.data_type || "UNKNOWN",
//             minOrderArea: product.min_order_area || 0,
//             satellites: product.satellites || [],
//             revisit: product.revisit ? `${product.revisit}` : 'N/A',
//             creditsPerSqkm: `${product.imagery_unit_price || 0}`,
//             areaCoverage: 0,
//           };
//         });
        
//         setConstellations(constellationList);
//       } catch (error) {
//         console.error('Error fetching constellation data:', error);
//       } finally {
//         setIsLoadingConstellations(false);
//       }
//     };

//     fetchConstellationData();
//   },[history, dateRange, drawnCoordinates]);
  

//   useEffect(() => {
//     // Report loading state to parent whenever it changes
//     if (loadingHandler) {
//       loadingHandler(loadingConstellation);
//     }
//   }, [loadingConstellation, loadingHandler]);

//   // New function to check feasibility (extracted from handleConstellationClick)
//   const checkFeasibility = async (constellationName, forceCheck = false) => {
//     // Find constellation ID by name
//     const constellation = constellations.find(c => c.name === constellationName);
//     if (!constellation) {
//       console.error(`Constellation ${constellationName} not found`);
//       return;
//     }

//     // Basic validation
//     if (!dateRange?.startDate || !dateRange?.endDate) {
//       setError({
//         constellation: constellationName,
//         message: 'Please select a date range'
//       });
//       return;
//     }

//     if (!drawnCoordinates || drawnCoordinates.length === 0) {
//       setError({
//         constellation: constellationName,
//         message: 'Please draw an area of interest'
//       });
//       return;
//     }

//     // Only proceed with API call if this is the first time checking or if forced refresh
//     if (forceCheck || !checkedConstellations[constellationName]) {
//       try {
//         // First set loading state
//         setLoadingConstellation(constellationName);
//         setError({ constellation: null, message: null });
        
//         // Hide any existing footprint before checking new constellation
//         onFootprintSelect({ coordinates: [], color: null });
        
//         // Format coordinates for the API
//         const formattedCoordinates = drawnCoordinates.map(coord => [coord.lng, coord.lat]);
        
//         // Create date string in the format "YYYY-MM-DD/YYYY-MM-DD"
//         const startDate = dayjs(dateRange.startDate).format('YYYY-MM-DD');
//         const endDate = dayjs(dateRange.endDate).format('YYYY-MM-DD');
//         const dateString = `${startDate}/${endDate}`;
    
//         const payload = {
//           coordinates: formattedCoordinates,
//           constellation: constellationName,
//           date: dateString,
//           constraints: {}
//         };
    
//         const token = localStorage.getItem('token');
//         const response = await fetch(SEARCH_URLS.checkFeasibility, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}`
//           },
//           body: JSON.stringify(payload)
//         });
    
//         if (response.status === 401) {
//           alert('Session expired. Please login again.');
//           localStorage.removeItem('token');
//           history.push('/login');
//           return;
//         }
    
//         if (!response.ok) {
//           const errorData = await response.json();
//           throw new Error(errorData.detail || 'Failed to check feasibility');
//         }
    
//         const responseData = await response.json();
//         console.log(responseData);
    
//         if (responseData.opportunities && responseData.opportunities.length > 0) {
//           const sortedOpportunities = responseData.opportunities.sort((a, b) => 
//             new Date(a.access_start) - new Date(b.access_start)
//           );
//           setSelectedConstellation(constellationName);
//           const firstStart = sortedOpportunities[0].access_start;
//           const lastEnd = sortedOpportunities[sortedOpportunities.length - 1].access_end;
    
//           const formatDateTime = (dateStr) => {
//             const date = new Date(dateStr);
//             return date.toLocaleString('en-GB', {
//               day: '2-digit',
//               month: 'short',
//               year: 'numeric',
//               hour12: false
//             });
//           };
    
//           const captureTimeRange = `${formatDateTime(firstStart)} to ${formatDateTime(lastEnd)}`;
//           let totalCoveragePercentage = responseData.opportunities.reduce((sum, opportunity) => 
//             sum + (opportunity.coverage_percentage || 0), 0);
          
//           if (totalCoveragePercentage > 100) {
//             totalCoveragePercentage = 100;
//           }
    
//           const newDetails = {
//             ...taskingDetails,
//             [constellationName]: {
//               opportunities: responseData.opportunities,
//               dateRange: {
//                 start: dateRange.startDate,
//                 end: dateRange.endDate
//               },
//               coordinates: drawnCoordinates,
//               areaCoverage: totalCoveragePercentage.toFixed(2),
//               captureTimeRange: captureTimeRange
//             }
//           };
    
//           setTaskingDetails(newDetails);
          
//           // Mark this constellation as checked AND expanded
//           setCheckedConstellations(prev => ({
//             ...prev,
//             [constellationName]: true
//           }));
          
//           // Always expand cards that have been checked
//           setExpandedConstellations(prev => ({
//             ...prev,
//             [constellationName]: true
//           }));
    
//           // If this constellation is currently selected, update parent components
//           if (selectedConstellation === constellationName) {
//             // Pass the data up to parent
//             onSelectionChange?.({
//               constellation: constellation,
//               details: newDetails[constellationName]
//             });
    
//             // Pass footprint coordinates
//             onFootprintSelect({
//               coordinates: responseData.opportunities.map(opp => opp.footprint_coordinates),
//               color: constellation.color,
//               constellation: constellation.name,
//               opportunities: responseData.opportunities
//             });
//           }
//         }
//       } catch (err) {
//         setError({
//           constellation: constellationName,
//           message: err.message || 'Failed to process selection. Please try again.'
//         });
//         console.error('Error in constellation selection:', err);
//       } finally {
//         setLoadingConstellation(null);
//       }
//     }
//   };

//   const handleConstellationClick = async (constellationName) => {
//     // Find constellation ID by name
//     const constellation = constellations.find(c => c.name === constellationName);
//     if (!constellation) {
//       console.error(`Constellation ${constellationName} not found`);
//       return;
//     }
    
//     // Toggle only the selection (highlight), not the expansion
//     if (selectedConstellation === constellationName) {
//       setSelectedConstellation(null);
//       // Hide footprint when deselecting
//       onFootprintSelect({ coordinates: [], color: null });
//     } else {
//       setSelectedConstellation(constellationName);
      
//       // If this constellation was already checked
//       if (checkedConstellations[constellationName]) {
//         // Show its footprint
//         onFootprintSelect({
//           coordinates: taskingDetails[constellationName]?.opportunities?.map(opp => opp.footprint_coordinates) || [],
//           color: constellation.color,
//           constellation: constellation.name,
//           opportunities: taskingDetails[constellationName]?.opportunities || []
//         });
        
//         // Pass selection change to parent
//         onSelectionChange?.({
//           constellation: constellation,
//           details: taskingDetails[constellationName]
//         });
        
//         return; // Skip the API call
//       }
      
//       // Check feasibility for newly selected constellation
//       await checkFeasibility(constellationName);
//     }
//   };

//   // New handler for refresh icon click
//   const handleRefreshClick = async (constellationName) => {
//     console.log(`Refreshing feasibility for ${constellationName}`);
    
//     // Force a recheck even if it's already been checked before
//     await checkFeasibility(constellationName, true);
//   };

//   return (
//     <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
//       <style>
//         {`
//           @keyframes pulse {
//             0% { opacity: 1; }
//             50% { opacity: 0.6; }
//             100% { opacity: 1; }
//           }
//           @keyframes spin {
//             from { transform: rotate(0deg); }
//             to { transform: rotate(360deg); }
//           }
//         `}
//       </style>
//       <Typography sx={{ color: '#76b6ff', fontSize: '12px', fontWeight: 500, py: 0.5, px: 1 }}>
       
//       </Typography>

//       {isLoadingConstellations ? (
//         <Box sx={{ 
//           flex: 1, 
//           display: 'flex', 
//           flexDirection: 'column', 
//           alignItems: 'center', 
//           justifyContent: 'center',
//           p: 2 
//         }}>
//           <Loader2 size={32} style={{ 
//             color: '#76b6ff', 
//             marginBottom: '12px',
//             animation: 'spin 1s linear infinite' 
//           }} />
//           <Typography sx={{ color: '#76b6ff', fontSize: '14px' }}>
//             Loading Products...
//           </Typography>
//         </Box>
//       ) : (
//         <Box sx={{ 
//           flex: 1,
//           overflowY: 'auto',
//           scrollbarWidth: 'thin',
//           scrollbarColor: 'rgba(255,255,255,0.1) transparent',
//           '&::-webkit-scrollbar': {
//             width: '2px'
//           },
//           '&::-webkit-scrollbar-track': {
//             background: 'transparent'
//           },
//           '&::-webkit-scrollbar-thumb': {
//             background: 'rgba(255,255,255,0.1)',
//             borderRadius: '1px'
//           }
//         }}>
//           <Typography sx={{ color: '#76b6ff', fontSize: '14px', fontWeight: 500, py: 0.5, px: 1 }}>
//             Available Constellations to Task
//           </Typography>
//           {constellations.map((constellation) => (
//             <ConstellationCard 
//               key={constellation.id}
//               {...constellation}
//               onCardClick={handleConstellationClick}
//               onRefreshClick={handleRefreshClick} // Pass the refresh handler
//               isSelected={selectedConstellation === constellation.name}
//               isExpanded={expandedConstellations[constellation.name] === true}
//               isLoading={loadingConstellation === constellation.name}
//               hasError={error.constellation === constellation.name}
//               errorMessage={error.constellation === constellation.name ? error.message : null}
//               opportunityCount={taskingDetails[constellation.name]?.opportunities?.length || 0}
//               areaCoverage={taskingDetails[constellation.name]?.areaCoverage || constellation.areaCoverage}
//               captureTimeRange={taskingDetails[constellation.name]?.captureTimeRange}
//             />
//           ))}
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default TaskingConstellations;